module.exports = __webpack_public_path__ + "static/media/logo-RocRoi.8a9e016f.png";